export default __webpack_public_path__ + "static/media/23.59a82d3b.svg";